export const NOTIFICATION_MODULE = {
    LEAVE_APPLICATION: "LEAVE_APPLICATION",
    PAYRUN: "PAYRUN",
    USER: "USER",
    PAYMENT: "PAYMENT"
}
export const NOTIFICATIONS = {
    EMPLOYEE_LEAVE_REQUEST: 'Employee Leave Request',
    EMPLOYEE_LEAVE_APPROVAL: 'Employee Leave Approval',
    EMPLOYEE_LEAVE_REJECTION: 'Employee Leave Rejection',
    PAYSLIP_GENERATED_USER: "Pay Slips Generation",
    PAYSLIP_GENERATED_ADMIN: "Pay Slips Generation",
    INCOMPLETE_USER: 'Incomplete Employee Profile',
    INCOMPLETE_USER_ADMIN: 'Incomplete Admin Profile',
    PAYRUN_PROCESSED: "Payrun Processed",
    SYNC_BENEFICIARY_FAILED: "Add Beneficiaries - Failed",
    SYNC_BENEFICIARY_PARTIALLY_COMPLETED: "Add Beneficiaries - Partially Success",
    SYNC_BENEFICIARY_COMPLETED: "Add Beneficiaries - Success",
    SALARY_TRANSFER_INITIATED: "Salary Transfer Initiated",
    SALARY_TRANSFER_COMPLETED: "Salary Transfer Completed",
    SALARY_TRANSFER_INCOMPLETE_FAILED: "Salary Transfer Failed",
    TRANSFER_FAILED: "Salary Transfer Failed",
    TRANSFER_INITIATED: "Salary Transfer Initiated",
    TRANSFER_SUCCESS: "Salary Transfer Completed",
}